import DefinitionList from './DefinitionList';
import { fmtDT, fmtDate } from '../utils/format';

/* Full ICIB-03b payload (GET /enrolments/{enrolment_id}) for whichever
   enrolment was selected — every field the endpoint returns, not just
   whatever preview the calling view's row already shows (FollowupView's
   notification row, ConfirmationsView's ICIB-12 row). `product`/`group`
   resolve the raw ids to names where that data is already loaded; the id
   itself is always shown too so the raw response stays fully visible.
   `note`, if given, is shown above the enrolment fields — FollowupView
   passes the notification's type/message; ConfirmationsView has nothing
   equivalent, so it omits the prop. */
function EnrolmentDrawer({ detail, note, product, group }) {
  const emp = detail.employee || {};
  const user = emp.user || {};
  const g = emp.company_id ? group(emp.company_id) : null;
  const p = detail.product_id ? product(detail.product_id) : null;

  return (
    <>
      {note && <div className="note" style={{ marginBottom: 16 }}>{note}</div>}

      <div className="sec-h" style={{ marginTop: 0 }}><h3>Enrolment</h3><span className="spacer" /><span className="ep">GET /enrolments/{'{enrolment_id}'}</span></div>
      <DefinitionList rows={[
        ['Enrolment ID', <span className="mono">{detail.enrolment_id}</span>],
        ['Status', <span className={'tag' + (detail.status === 'onboarded' ? ' ok' : detail.status === 'archived' ? '' : detail.status === 'removed' ? ' off' : ' warn')}>{detail.status}</span>],
        ['Product', p ? p.name : <span className="mono">{detail.product_id}</span>],
        ['Invited at', detail.invited_at ? fmtDT(detail.invited_at) : '—'],
        ['Employment effective date', fmtDate(detail.effective_date)],
        ['Reason', detail.reason || '—'],
        ['Removal reason', detail.removal_reason || '—'],
        ['Removal effective date', fmtDate(detail.removal_effective_date)],
      ]} />

      <div className="sec-h"><h3>Employee</h3></div>
      <DefinitionList rows={[
        ['Employee ID', <span className="mono">{emp.employee_id}</span>],
        ['Company', g ? `${g.name} · ${g.company_code}` : <span className="mono">{emp.company_id}</span>],
        ['Name', `${user.first_name || ''} ${user.last_name || ''}`.trim() || '—'],
        ['Email', user.email || '—'],
        ['Date of birth', user.dob || '—'],
        ['Phone', user.phone || '—'],
        ['Address', user.address || '—'],
        ['Gender', user.gender || '—'],
      ]} />
    </>
  );
}

export default EnrolmentDrawer;
